import React from 'react';
import ProjectSidebarComponent from './ProjectSidebarComponent';
import { PageHeader } from '../../components';

const ActivatedCarbonFiltersAcf: React.FC = () => {
  return (
    <>
      <PageHeader title="Activated Carbon Filters (ACF)" breadcrumbs={[{ label: "Projects", path: "/projects" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/compact_stp.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/etp.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">Activated Carbon Filters (ACF)</h1>
              
              <h3 className="mb-4">Overview</h3>
              <p>Activated Carbon Filters (ACFs) play a vital role in removing organic contaminants, chlorine, colour, odour, and residual disinfectants from water. At Wasser Technochem (India) Ltd., our ACF systems are designed to deliver high adsorption capacity, long service life, and compatibility with downstream membrane or ion-exchange units.</p>

              <h3 className="mb-4">Applications</h3>
              <p><i className="fa fa-leaf text-primary me-2"></i>Pre-treatment before RO, UF, or EDI systems</p>
              <p><i className="fa fa-leaf text-primary me-2"></i>Removal of chlorine and organic compounds</p>
              <p><i className="fa fa-leaf text-primary me-2"></i>Odour and colour control in potable water</p>
              <p><i className="fa fa-leaf text-primary me-2"></i>Polishing filters in drinking water treatment</p>
              <p><i className="fa fa-leaf text-primary me-2"></i>Effluent treatment polishing in ETPs & STPs</p>
              <p><i className="fa fa-leaf text-primary me-2"></i>Food, beverage, pharmaceutical and chemical industries</p>

              <h3 className="mb-4">Our Capabilities</h3>
              <p className="mb-4">WTIL offers fully engineered ACF units for industrial, commercial, and municipal applications. Our designs consider the specific chlorine load, organic contamination, and flow rate to ensure optimum performance.</p>
              
              <h4 className="mb-3">Key Features:</h4>
              <div className="mb-4">
                <h5><i className="fa fa-gem text-primary me-2"></i>High-Grade Activated Carbon Media</h5>
                <p className="ms-4">We use steam-activated granular carbon with high surface area for efficient adsorption.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-industry text-primary me-2"></i>MOC Options: FRP / MSRL / SS 304</h5>
                <p className="ms-4">Based on flow, temperature, and corrosive characteristics of water.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-sync-alt text-primary me-2"></i>Auto/Manual Backwash & Rinsing Cycles</h5>
                <p className="ms-4">To maintain media life and avoid clogging or channelling.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-link text-primary me-2"></i>Integration with Other Units</h5>
                <p className="ms-4">Can be easily linked with MGFs, DM plants, UF/RO systems, or polishing filters.</p>
              </div>

              <h3 className="mb-4">Benefits</h3>
              <p><i className="fa fa-check-circle text-success me-2"></i>Protects membranes, resins, and EDI stacks from oxidation</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Reduces organics, THMs, color, and taste issues</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Minimal pressure drop and low maintenance</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Improves life and reliability of complete water systems</p>

              <h3 className="mb-4">Why WTIL?</h3>
              <p><i className="fa fa-star text-warning me-2"></i>Over 25 years of experience across power, textile, chemical, and food sectors</p>
              <p><i className="fa fa-star text-warning me-2"></i>Performance-optimized carbon filters for variable water quality in India</p>
              <p><i className="fa fa-star text-warning me-2"></i>O&M support and carbon media replacement services</p>
              <p className="mb-5"><i className="fa fa-star text-warning me-2"></i>Proven results in high TDS, COD/BOD applications</p>
            </div>

            <div className="col-lg-4">
              <ProjectSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default ActivatedCarbonFiltersAcf;
